import { render, staticRenderFns } from "./StructureEditPhotos.vue?vue&type=template&id=184c2e2a"
import script from "./StructureEditPhotos.vue?vue&type=script&lang=js"
export * from "./StructureEditPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports